import NewsService from "./NewsService"
import SocialService from "~/components/social/SocialService"
import { ucfirst, ellipsis } from "~/lib/utils"
import DEFAULT_I18N from "~/i18n"

export const mutations = {
    setNewsItem(state, newsItem) {
        state[newsItem.newsId] = newsItem
    },
}

export function makeActions({ service, socialService, i18n }) {
    i18n = i18n || DEFAULT_I18N.global
    return {
        async refreshNewsItem({ commit }, newsId) {
            const newsItem = await service.getNewsItem(newsId)
            commit("setNewsItem", newsItem)
        },

        async sendLike({ state, commit, dispatch }, { newsId }) {
            const newsItem = state[newsId]
            if (!newsItem) {
                throw new Error(`News item ${newsId} doesn't exist`)
            }
            const originalNewsItem = Object.assign({}, newsItem)
            const { liked, likes } = originalNewsItem.social
            const social = Object.assign({}, originalNewsItem.social, {
                liked: !liked,
                likes: liked ? likes - 1 : likes + 1,
            })
            const optimisticNewsItem = Object.assign({}, newsItem, { social })
            commit("setNewsItem", optimisticNewsItem)

            try {
                const newNewsItem =
                    await socialService.likeResource(optimisticNewsItem)
                commit("setNewsItem", newNewsItem)
            } catch (error) {
                commit("setNewsItem", originalNewsItem)
                dispatch(
                    "pushNotification",
                    {
                        title: error.message,
                        type: "error",
                    },
                    { root: true }
                )
            }
        },

        async sendBookmark({ state, commit, dispatch }, { newsId }) {
            const newsItem = state[newsId]
            if (!newsItem) {
                throw new Error(`News item ${newsId} doesn't exist`)
            }
            const social = Object.assign({}, newsItem.social)
            social.bookmarked = !social.bookmarked
            const originalNewsItem = Object.assign({}, newsItem)
            const optimisticNewsItem = Object.assign({}, newsItem, { social })
            commit("setNewsItem", optimisticNewsItem)

            try {
                const newNewsItem =
                    await socialService.bookmarkResource(optimisticNewsItem)
                commit("setNewsItem", newNewsItem)
                const info = newNewsItem.social.bookmarked
                    ? i18n.t("common.wasAddedToBookmarks")
                    : i18n.t("common.wasRemovedFromBookmarks")

                dispatch(
                    "pushNotification",
                    {
                        title: ucfirst(ellipsis(newNewsItem.title, 75)),
                        info: ucfirst(info),
                        type: newNewsItem.social.bookmarked
                            ? "success"
                            : "info",
                    },
                    { root: true }
                )
            } catch (error) {
                commit("setNewsItem", originalNewsItem)
                dispatch(
                    "pushNotification",
                    {
                        title: error.message,
                        type: "error",
                    },
                    { root: true }
                )
            }
        },

        async updateCommentsCount(
            { state, commit },
            { newsId, commentsCount }
        ) {
            const newsItem = state[newsId]
            if (!newsItem) {
                throw new Error(`News item ${newsId} doesn't exist`)
            }
            const social = Object.assign({}, newsItem.social, { commentsCount })

            const newNewsItem = Object.assign({}, newsItem, { social })

            commit("setNewsItem", newNewsItem)
        },
    }
}

export default {
    namespaced: true,
    state: {},
    mutations,
    actions: makeActions({
        service: new NewsService(),
        socialService: new SocialService(),
    }),
}
